import axios from "axios";
import { setToast } from "../State/toastSlice";
import store from "../State/Store";
// Create an Axios instance with custom configuration
const apisecured = axios.create({
  baseURL: "https://api.sponsa.app/v1/",
  //baseURL: "https://localhost:44375/v1/",
  withCredentials: true, // Sends cookies with every request
});

// Optional: Add a request interceptor
apisecured.interceptors.request.use(
  (config) => {
    // You can add headers or any other config modifications here
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Optional: Add a response interceptor
apisecured.interceptors.response.use(
  (response) => {
    return response; // ✅ Return successful responses
  },
  (error) => {
    if (error.response) {
      // 🚨 If Unauthorized (401), redirect to login page
      if (error.response.status === 401) {
        store.dispatch(
          setToast({
            message: `Session expired. Redirecting to login.`,
            type: "error",
          }),
        );
        setTimeout(() => {
          window.location.href = "/account"; // Redirect after 1 second
        }, 1000);
      } else if (error.response.status === 403) {
        console.log(error.response.data?.ErrorMessage);
      } else {
        store.dispatch(
          setToast({
            message:
              error.response.data?.ErrorMessage ||
              "An unexpected error occurred.",
            type: "error",
          }),
        );
      }
    } else {
      store.dispatch(
        setToast({
          message: "Network error. Please check your connection.",
          type: "error",
        }),
      );
    }
    return Promise.reject(error); // Reject the error so it can be handled elsewhere if needed
  },
);

export default apisecured;
